import type { AccountDropdownSettings } from "../../../Header";

export const getGreetingTitle = (
  userName: string | undefined,
  accountDropdownSettings?: Pick<AccountDropdownSettings, "greetingMessage" | "hideGreetingMessage">
): string | undefined => {
  if (!userName || !accountDropdownSettings?.greetingMessage) {
    return undefined;
  }

  if (accountDropdownSettings.hideGreetingMessage) {
    return accountDropdownSettings.greetingMessage;
  }

  return `${accountDropdownSettings.greetingMessage} ${userName}`;
};
